import { map, Observable, lastValueFrom } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { User } from '../models/user';
import { SettingsService } from '../services/settings.service';
import { ServerResponse } from '../response';

@Injectable({
  providedIn: 'root',
})
export class AuthDomainService {
  constructor(
    private settingService: SettingsService,
    private http: HttpClient
  ) {}

  // проверка авторизован ли пользователь
  checkAuth(): Observable<User | null> {
    return this.http
      .get<ServerResponse<any>>(`${this.settingService.settings.urlGTM}/api/auth/check`)
      .pipe(map((response: ServerResponse<any>) => response.data));
  }

  // отправка пинкода новому пользователю или пароля уже зарегистрированному
  sendPin(phone: string, mode: 'pin' | 'default' = 'default'): Promise<void> {
    return lastValueFrom(
      this.http
        .post<ServerResponse<any>>(
          `${this.settingService.settings.urlGTM}/api/auth/send_pin`,
          { phone, mode, lang: this.settingService.selectedLang }
        )
        .pipe(
          map((res: any) => res.data)
        )
    );
  }

  // авторизация пользователя
  auth(phone: string, data: string, resume = false, socketSid: string): Promise<any> {
    return lastValueFrom(
      this.http
        .post<ServerResponse<any>>(`${this.settingService.settings.urlGTM}/api/auth`, {
          phone,
          pass: data,
          lang: this.settingService.selectedLang,
          status: resume,
          socketSid,
        })
        .pipe(
          map((response: ServerResponse<any>) => response.data)
        )
    );
  }

  // инициализация отправки на почту пинкода
  initEmail(email: string, lang: 'ru' | 'us'): Promise<void> {
    return lastValueFrom(
      this.http
        .post<ServerResponse<any>>(
          `${this.settingService.settings.urlGTM}/api/auth/email_verification`,
          { email, lang }
        )
        .pipe(
          map((res: any) => res.data)
        )
    );
  }

// инициализация входа по звонку (sms.ru callcheck) —
  // возвращает номер, на который пользователь должен позвонить
  initCallCheck(phone: string): Promise<any> {
    return lastValueFrom(
      this.http
        .post<ServerResponse<any>>(
          `${this.settingService.settings.urlGTM}/api/auth/init_call_check`,
          { phone, lang: this.settingService.selectedLang }
        )
        .pipe(
          map((res: any) => res.data)
        )
    );
  }

  // проверка статуса подтверждения звонка (polling).
  // Сервер при подтверждении сам авторизует пользователя в сессии и возвращает данные пользователя.
  callcheckStatus(checkId: string): Promise<any> {
    return lastValueFrom(
      this.http
        .get<ServerResponse<any>>(
          `${this.settingService.settings.urlGTM}/api/auth/callcheck_status`,
          { params: { check_id: checkId, lang: this.settingService.selectedLang } }
        )
        .pipe(
          map((res: any) => res.data)
        )
    );
  }

  // используется для изменения номера телефона у пользователя
  setPhoneVerified(phone: string, cUid: string, pincode: string): Promise<any> {
    return lastValueFrom(
      this.http
        .patch<ServerResponse<any>>(
          `${this.settingService.settings.urlGTM}/api/user/phone`,
          { phone, cUid, pincode, lang: this.settingService.selectedLang }
        )
        .pipe(
          map((response: ServerResponse<any>) => response.data)
        )
    );
  }

  // логаут из профиля пользователя
  logout(): Observable<void> {
    return this.http
      .get(`${this.settingService.settings.urlGTM}/api/auth/logout`)
      .pipe(
        map(() => undefined)
      );
  }
}
